import ManagementPageHTML, {
  IdentityCell,
  StatusBadge,
} from "../../components/ManagementPage/ManagementPageHTML";
import type { ManagementColumn } from "../../components/ManagementPage/ManagementPageTypes";
import type { OrderStatusHistory } from "../../models/OrderStatusHistory";
import { OrderStatusHistoryService } from "../../services/OrderStatusHistoryService";
const columns: ManagementColumn<OrderStatusHistory>[] = [
  {
    Key: "Order",
    Header: "Order",
    Render: (row) => (
      <IdentityCell
        Icon="fa-clock-rotate-left"
        Title={row.OrderCode}
        Subtitle={row.Code}
      />
    ),
  },
  {
    Key: "Previous",
    Header: "Previous",
    Render: (row) => <StatusBadge Status={row.PreviousStatus} />,
  },
  {
    Key: "New",
    Header: "New",
    Render: (row) => <StatusBadge Status={row.NewStatus} />,
  },
  { Key: "Comment", Header: "Comment", Render: (row) => row.Comment || "—" },
  {
    Key: "Changed",
    Header: "Changed at",
    Render: (row) => new Date(row.ChangedAt).toLocaleString("en-NG"),
  },
  { Key: "User", Header: "Changed by", Render: (row) => row.ChangedBy },
];
export default function OrderHistoryHTML() {
  return (
    <ManagementPageHTML
      Service={OrderStatusHistoryService()}
      CanCreate={false}
      CanEdit={false}
      CanDelete={false}
      Title="Order history"
      Eyebrow="Order audit"
      Description="Review every order status transition and the user who made it."
      AddLabel="Add history"
      SearchPlaceholder="Search order or user"
      Rows={[]}
      Columns={columns}
      GetRowKey={(row) => row.Code}
      GetSearchText={(row) =>
        `${row.OrderCode} ${row.ChangedBy} ${row.Comment ?? ""}`
      }
      Summaries={[]}
      GetSummaries={(rows, total) => [
        {
          Label: "Changes",
          Value: total,
          Icon: "fa-clock-rotate-left",
          Tone: "Blue",
        },
        {
          Label: "Completed",
          Value: rows.filter((x) => x.NewStatus === "Completed").length,
          Icon: "fa-circle-check",
          Tone: "Green",
        },
        {
          Label: "Cancelled",
          Value: rows.filter((x) => x.NewStatus === "Cancelled").length,
          Icon: "fa-circle-xmark",
          Tone: "Red",
        },
        {
          Label: "Users",
          Value: new Set(rows.map((x) => x.ChangedBy)).size,
          Icon: "fa-users",
          Tone: "Purple",
        },
      ]}
    />
  );
}
